module.exports = __webpack_public_path__ + "static/media/glass@2x.12b17aab.png";